(() => {
  const init = (root) => {
    if (!root || root.dataset.reelReady === 'true') return;
    root.dataset.reelReady = 'true';

    const track = root.querySelector('[data-reel-track]');
    const prev = root.querySelector('[data-reel-prev]');
    const next = root.querySelector('[data-reel-next]');
    const dots = Array.from(root.querySelectorAll('[data-reel-dot]'));
    if (!track) return;

    const originals = Array.from(track.querySelectorAll('[data-reel-card]'));
    const count = originals.length;
    if (!count) return;

    originals.forEach((card) => {
      const clone = card.cloneNode(true);
      clone.removeAttribute('data-shopify-editor-block');
      track.appendChild(clone);
    });

    const cards = Array.from(track.querySelectorAll('[data-reel-card]'));

    const gap = () => {
      const style = window.getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap) || 0;
    };

    const step = () => {
      const first = cards[0];
      return first ? first.getBoundingClientRect().width + gap() : 0;
    };

    const originalWidth = () => step() * count;

    const playVideos = (scope) => {
      scope.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        const play = video.play();
        if (play && typeof play.catch === 'function') play.catch(() => {});
      });
    };

    const nearestIndex = () => {
      const width = step() || 1;
      return Math.round(track.scrollLeft / width);
    };

    const logicalIndex = () => {
      const index = nearestIndex();
      return ((index % count) + count) % count;
    };

    const updateDots = () => {
      const index = logicalIndex();
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    const normalize = () => {
      const width = originalWidth();
      if (!width) return;
      if (track.scrollLeft >= width) {
        track.scrollLeft -= width;
      } else if (track.scrollLeft < 0) {
        track.scrollLeft += width;
      }
    };

    let ticking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          normalize();
          updateDots();
          ticking = false;
        });
      },
      { passive: true }
    );

    const go = (dir) => {
      const width = step();
      if (!width) return;
      if (dir < 0 && track.scrollLeft < 8) {
        track.scrollLeft += originalWidth();
      }
      track.scrollBy({ left: dir * width, behavior: 'smooth' });
      window.setTimeout(normalize, 420);
    };

    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const width = step();
        const current = logicalIndex();
        let target = index;
        if (current > count / 2 && index < current) {
          target = index + count;
        }
        track.scrollTo({ left: target * width, behavior: 'smooth' });
        window.setTimeout(normalize, 420);
      });
    });

    const bindToggle = (button) => {
      const video = button.closest('[data-reel-card]')?.querySelector('video');
      if (!video || button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      const pauseIcon = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
      const playIcon = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.8v12.4L19 12 8 5.8z"/></svg>';
      const sync = () => {
        button.innerHTML = video.paused ? playIcon : pauseIcon;
        button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      };
      button.addEventListener('click', () => {
        if (video.paused) video.play();
        else video.pause();
        sync();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    };

    track.querySelectorAll('[data-reel-toggle]').forEach(bindToggle);
    playVideos(track);
    updateDots();
  };

  const start = () => document.querySelectorAll('[data-reviews-reel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-reviews-reel]');
    if (root) {
      delete root.dataset.reelReady;
      init(root);
    }
  });
})();
